import di from "../../features/TOC/di/servicelocator";
import React, { useEffect, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import security from "../../../assets/images/features/TOC/Common/security.svg";
import EdButton, { EdLinkButton } from "../edbutton/edButton";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthSellNavigationState, } from "@frameworks/web/components/features/EDIS/Constant";
import { isEqual } from "underscore";
const AuthoriseToSell = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const navigate = useNavigate();
    const formRef = useRef(null);
    const location = useLocation()
        .state;
    const [successMessage, setSuccessMessage] = React.useState("");
    const [holdingData, setHoldingData] = React.useState({
        dp: "",
        email: "",
        mob: "",
        setDt: "",
        setId: "",
        lst: [],
    });
    const rmsHoldingData = useSelector((state) => state.TOCJourney.rmsDetails.rmsHolding, isEqual);
    const edisHoldingData = useSelector((state) => state.EDIS.edisHoldingReducer.data, isEqual);
    const { data: proceedToAuth, loader: proceedToAuthLoader, errorData: proceedToAuthError, } = useSelector((state) => state.TOCJourney.proceedToAuth, isEqual);
    const getTpin = () => {
        const req = {
            dp: edisHoldingData.dpId,
            email: edisHoldingData.email,
            mob: edisHoldingData.mobile,
        };
        di.tocJourney.getTpinApiDetails(req).then((data) => {
            if (data.success) {
                setSuccessMessage("TPIN generated successfully");
            }
            else {
            }
        });
    };
    const proceedToAuthorize = () => {
        const req = {
            dpId: holdingData.dp,
            setDt: holdingData.setDt,
            setId: holdingData.setId,
            lst: holdingData.lst,
        };
        di.tocJourney.proceedToAuthorize(req);
    };
    const mantainListData = () => {
        var _a, _b;
        const list = [];
        (_b = (_a = edisHoldingData === null || edisHoldingData === void 0 ? void 0 : edisHoldingData.auth) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.forEach((x) => {
            if (x.select) {
                list.push({
                    bseSym: x.bseSym,
                    isin: x.isin,
                    nseSym: x.nseSymbol,
                    qty: x.quantity,
                    ref: x.ref,
                    select: x.select,
                    setDt: x.setDate,
                    setId: x.setId,
                    settType: x.setType,
                    sts: x.status,
                    sym: x.symbol,
                    symNm: x.symbolName,
                });
            }
        });
        return list;
    };
    const backBtnHandler = () => {
        switch (location === null || location === void 0 ? void 0 : location.screen) {
            case AuthSellNavigationState.EDIS:
                return navigate(-1);
            default:
                return (props === null || props === void 0 ? void 0 : props.setProceedToAuthorize) && (props === null || props === void 0 ? void 0 : props.setProceedToAuthorize(false));
        }
    };
    const screenStateHandler = () => {
        var _a, _b, _c, _d, _e;
        if (location === null || location === void 0 ? void 0 : location.screen) {
            switch (location === null || location === void 0 ? void 0 : location.screen) {
                case AuthSellNavigationState.EDIS:
                    setHoldingData({
                        dp: edisHoldingData.dpId,
                        email: edisHoldingData.email,
                        mob: edisHoldingData.mobile,
                        setDt: edisHoldingData.setDate,
                        setId: edisHoldingData.setId,
                        lst: location === null || location === void 0 ? void 0 : location.list,
                    });
                    return;
                default:
                    setHoldingData({
                        dp: (_a = rmsHoldingData === null || rmsHoldingData === void 0 ? void 0 : rmsHoldingData.auth) === null || _a === void 0 ? void 0 : _a.dpId,
                        email: (_b = rmsHoldingData === null || rmsHoldingData === void 0 ? void 0 : rmsHoldingData.auth) === null || _b === void 0 ? void 0 : _b.setDt,
                        mob: rmsHoldingData === null || rmsHoldingData === void 0 ? void 0 : rmsHoldingData.mob,
                        setDt: (_c = rmsHoldingData === null || rmsHoldingData === void 0 ? void 0 : rmsHoldingData.auth) === null || _c === void 0 ? void 0 : _c.setDt,
                        setId: (_d = rmsHoldingData === null || rmsHoldingData === void 0 ? void 0 : rmsHoldingData.auth) === null || _d === void 0 ? void 0 : _d.setId,
                        lst: (_e = rmsHoldingData === null || rmsHoldingData === void 0 ? void 0 : rmsHoldingData.auth) === null || _e === void 0 ? void 0 : _e.lst,
                    });
                    return;
            }
        }
    };
    useEffect(() => {
        var _a;
        if (!proceedToAuthLoader &&
            !proceedToAuthError.isOpen &&
            proceedToAuth.sts === "Ok" &&
            proceedToAuth.cpld.url) {
            (_a = formRef === null || formRef === void 0 ? void 0 : formRef.current) === null || _a === void 0 ? void 0 : _a.submit();
        }
        //   else if(proceedToAuthError?.isOpen&&proceedToAuthError?.error){
        //   setStatusMsg((proceedToAuthError?.error as EdelError)?.getErrMsg())
        //   TpinGenerateModal && setTpinGenerateModal(false)
        // }
    }, [proceedToAuth, proceedToAuthLoader, proceedToAuthError]);
    useEffect(() => {
        screenStateHandler();
    }, [edisHoldingData]);
    return (React.createElement("div", { className: "bg_white" },
        React.createElement("div", { className: "d-flex justify-content-center pt-5" },
            React.createElement("img", { src: security, alt: "" })),
        React.createElement(Row, { className: "m-0 DMSansBold_20_700 d-flex justify-content-center auth-heading" }, "Authorize to sell"),
        React.createElement(Row, { className: "m-0 DMSanM_14_500 txt_blackOne1 auth-msg text-center" }, "Selling your holdings requires authorization using CDSL TPIN. You\u2019ll be redirected to CDSL website"),
        React.createElement(Row, { className: "authorise-msg text-center bg_pastel-cream" },
            React.createElement("div", { className: "DMSansMedium_12_500 txt-orange-light" }, "Buying of authorized scrips will be disallowed in NRML, MTF and MIS products for the day")),
        props.hideshowCDSL ? null : (React.createElement(Row, { className: "m-0 proceed-button d-flex justify-content-center removecapitalize" },
            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Proceed to CDSL", onClick: () => proceedToAuthorize() }))),
        props.hideBackTpin ? null : (React.createElement(Row, { className: "m-0 back-tpin" },
            React.createElement(Col, null,
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Go Back", className: "DMSanM_14_500", onClick: backBtnHandler })),
            React.createElement(Col, { className: "text-end" },
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Get TPIN", className: "DMSa.nM_14_500", onClick: () => getTpin() })))),
        React.createElement("p", null, successMessage),
        props.messagecontent ? React.createElement(React.Fragment, null, props.messagecontent) : null,
        props.showTpin ? (React.createElement(Row, { className: "m-0 proceed-button d-flex justify-content-center" },
            React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Get TPIN", onClick: () => getTpin() }))) : null,
        React.createElement(Row, { className: "m-0 note-section DMSansMedium_12_500" },
            React.createElement("div", { className: "txt_blackOne1 py-2 px-0" }, "Please Note"),
            React.createElement("ul", { className: "txt_primaryGrey" },
                React.createElement("li", null, "Authorisation can be done between 12:00 AM & 09:00 PM on trading days"),
                React.createElement("li", null, "Authorisation will be valid for one day"),
                React.createElement("li", null,
                    "As additional verification, an OTP will be sent on your registered mobile: ", holdingData === null || holdingData === void 0 ? void 0 :
                    holdingData.mob),
                React.createElement("li", null,
                    "Have More Questions?\u00A0",
                    React.createElement(EdLinkButton, { LinkHref: "", btnTyp: "link", value: "Read FAQs", className: "DMSansMedium_12_500" })))),
        ((_a = proceedToAuth === null || proceedToAuth === void 0 ? void 0 : proceedToAuth.cpld) === null || _a === void 0 ? void 0 : _a.url) &&
            React.createElement("form", { ref: formRef, id: "edisForm1", name: "frmDIS1", method: "POST", action: (_b = proceedToAuth === null || proceedToAuth === void 0 ? void 0 : proceedToAuth.cpld) === null || _b === void 0 ? void 0 : _b.url },
                React.createElement("input", { type: "hidden", name: "DPId", value: (_c = proceedToAuth === null || proceedToAuth === void 0 ? void 0 : proceedToAuth.cpld) === null || _c === void 0 ? void 0 : _c.dp }),
                React.createElement("input", { type: "hidden", name: "ReqId", value: (_d = proceedToAuth === null || proceedToAuth === void 0 ? void 0 : proceedToAuth.cpld) === null || _d === void 0 ? void 0 : _d.reqId }),
                React.createElement("input", { type: "hidden", name: "Version", value: (_e = proceedToAuth === null || proceedToAuth === void 0 ? void 0 : proceedToAuth.cpld) === null || _e === void 0 ? void 0 : _e.vsn }),
                React.createElement("input", { type: "hidden", name: "TransDtls", value: (_f = proceedToAuth === null || proceedToAuth === void 0 ? void 0 : proceedToAuth.cpld) === null || _f === void 0 ? void 0 : _f.req }))));
};
export default AuthoriseToSell;
